<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">

    <div class="card shadow-0 border-0" style="background-color:inherit">
      <div class="card-body skin light-bg text-center card-img-top">
        <div class="card-img-actions d-inline-block mb-3">
          <img class="rounded-circle" v-bind:src="getUserImgUrl(username)" alt="">
        </div>

        <h6 class="font-weight-semibold mb-0 font-weight-bolder">{{firstname}} {{lastname}}</h6>
        <span v-if="role != null && role != ''" class="d-block opacity-75">{{role}}<br /></span>
        <span v-if="phone != null && phone != ''" class="d-block opacity-75">Tel: {{phone}}<br /></span>
        <span v-if="lastlogin != null && lastlogin != ''" class="d-block opacity-75">{{$t('lastlogin')}}: {{lastlogin}}<br /></span>

        <ul class="list-inline list-inline-condensed mt-3 mb-0">
          <li v-if="phone != null && phone != ''" class="list-inline-item">
            <a v-bind:href="'tel:' + phone" class="btn btn-outline-dark btn-icon border-2 rounded-pill">
              <i class="icon-phone2"></i>
            </a>
          </li>
          <li v-if="skype != null && skype != ''" class="list-inline-item">
            <a v-bind:href="'skype:' + skype + '?call'" class="btn btn-outline-dark btn-icon border-2 rounded-pill">
              <i class="icon-skype"></i>
            </a>
          </li>
          <li v-if="email != null && email != ''" class="list-inline-item">
            <a v-bind:href="'mailto:' + email " class="btn btn-outline-dark btn-icon border-2 rounded-pill">
              <i class="icon-envelop3"></i>
            </a>
          </li>
        </ul>
        <div class="container-fluid" v-if="latestShifts.length > 0">
          <div class="row">
            <div class="col text-center pt-3">
              <div><b>{{$t('last_7_days')}}:</b></div>
              <table align="center">
                <tr v-for="row in latestShifts">
                  <td class="py-0 pt-1" valign="top" @click="selectDate(row.datestr)" style="cursor:pointer"><u>{{row.date}}</u></td>
                  <td class="py-0 pt-1">{{row.locationname}} {{row.shiftname}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let message = "";
  export default {
    name: "contact-card",
    components: {

    },
    props: {
      username: {
        type: String,
        default: null
      },
    },
    data() {
      return {
        latestShifts:[],
        message: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        address: "",
        role: "",
        notes: "",
        roledescription: "",
        skype: "",
        facebook: "",
        linkedin: "",
        lastlogin: "",
      };
    },
    methods: {
      getUserImgUrl(username){
        return apiUrl+ '/api/Memberships/v1/User/SquareImage?username=' + username;
      },
      selectDate(date) {
        this.$emit("selectdate", date);
      },
      async getUserSchedulings(username) {
        this.$http.get(`/api/Admin/v1/Users/LastShifts?username=${username}`).then(async response => {
          this.latestShifts = response.data;
        });
      },
      async getContact(username) {
        try {
          this.$http.get('/api/Contacts/v1/ByUsername?username=' + username).then(async response => {

            if (response != null && response.data != null && response.data != "") {
              var contact = response.data;
              this.firstname = contact.FirstName;
              this.lastname = contact.LastName;
              this.email = contact.Email;
              this.phone = contact.Phone;
              this.address = contact.Address;
              this.role = contact.Role;
              this.notes = contact.Notes;
              this.roledescription = contact.Roledescription;
              this.skype = contact.Skype;
              this.facebook = contact.Facebook;
              this.linkedin = contact.Linkedin;
              this.lastlogin = contact.LastLogin
            }
            else {
              this.firstname = username;
            }

          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      username: function (newVal, oldVal) {
        if (newVal != null) {
          this.getContact(newVal);
        }
      }
    },
    mounted() {
      if (this.username != null) {
        this.getContact(this.username);
        this.getUserSchedulings(this.username);
      }
    }
  };
</script>
<style scoped>
  .rounded-circle {
    width: 150px;
    height: 150px;
  }

  @media (max-width: 768px) {

    .rounded-circle {
      width: 50px;
      height: 50px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/contact/contact-card.vue